import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgVideo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M18 4H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 2v12H3V6h14Z" />
      <path d="m21.355 6.236-4 3.375a1 1 0 0 0-.355.764v3.25a1 1 0 0 0 .355.764l4 3.375A1 1 0 0 0 23 17V7a1 1 0 0 0-1.645-.764ZM21 9.15v5.697l-2-1.688v-2.321l2-1.688ZM7.732 8.86a1 1 0 0 1 1.307-.203l.101.075 3 2.5a1 1 0 0 1 .09 1.452l-.09.084-3 2.5a1 1 0 0 1-1.372-1.45l.092-.086L9.937 12 7.86 10.268a1 1 0 0 1-.203-1.307l.075-.101Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgVideo)
const Memo = memo(ForwardRef)
export default Memo
